import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../stores/auth.store';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated()) return true;

  return router.createUrlTree(['auth/login'], {
    queryParams: route.queryParams,
  });
};
